/*
  ___  ___
  |  \/  |
  | .  . |
  | |\/| |
  | |  | |
  \_|  |_/

  TODO
  - hook this up to breakpoints from the actual sass code
  - make sure breakpoints are sorted first, ascending order
  - finish the JS API for getters

  ALT APPROACH -- better performance??
  - track window resize events...
  - track matchers and match values in a map, emit 'flip' or 'break' when they break
  e.g.
      const mmMap = new WeakMap();
      let match;
      currMatch = matcher.matches
      if (currMatch !== mmMap[matcher]) { this.emit('flip', key); }
      mmMap.set(matcher, currMatch)

*/

import { raf } from "../abstract/raf";
import { SyncEmitter } from "../abstract/emit.js";

export const cssMedia = {
  xs: { breakpoint: "26em" },
  s: { breakpoint: "36em" },
  m: { breakpoint: "52em" },
  l: { breakpoint: "72em" },
  xl: { breakpoint: "104em" },
};

const mediaKeys = Object.keys(cssMedia);

const Media = new SyncEmitter();

const matchers = {},
  listeners = {};

mediaKeys.forEach((key, i, keys) => {
  const matcher = window.matchMedia(
    `(min-width: ${cssMedia[key]["breakpoint"]})`,
  );
  function listener(matcher) {
    const match = matcher.matches;
    Media.emit("break", key, i, keys, match);
    Media.emit(`break-${key}`, i, keys, match);
    Media.emit(`${match ? "match" : "unmatch"}-${key}`, i, keys);
    Media.emit(`${match ? "above" : "below"}-${key}`, i, keys);
  }
  matchers[key] = matcher;
  listeners[key] = listener;
  matcher.addListener(listener);
  Media.on("init", () => listener(matcher));
});

Object.assign(Media, { matchers, listeners });

Media.on("break", () => {
  Media.currMin = mediaKeys.filter((key) => matchers[key].matches).reverse()[0];
  Media.currMax = mediaKeys.filter((key) => !matchers[key].matches)[0];
  // console.log(`
  //   current gt: ${Media.currMin}
  //   current lt: ${Media.currMax}
  // `);
});

Object.assign(Media, {
  keys: mediaKeys,
  data: cssMedia,
  currMin: null,
  currMax: null,
  isBelow(key) {
    return !matchers[key].matches;
  },
  isAbove(key) {
    return matchers[key].matches;
  },
});

window.setTimeout(function () {
  Media.emit("init");
}, 0);

export default Media;
